<!-- 产品中心 -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.cps_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <p class="littitle">{{text.product1}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productew/ysjsew">{{text.product2}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/lbew">{{text.product3}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/crqdew">{{text.product4}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.product5}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productew/kcpew">{{text.product6}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/hhxtew">{{text.product7}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/xtghjew">{{text.product8}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/jsgew">{{text.product9}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/ntew">{{text.product10}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.product11}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productew/tszpew">{{text.product12}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/lytkew">{{text.product13}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/yjmew">{{text.product14}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.product15}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productew/yybjew">{{text.product16}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/cytqwew">{{text.product17}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/chsew">{{text.product18}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/ggtqwew">{{text.product19}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/sfjtqwew">{{text.product20}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/ptztqwew">{{text.product21}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/lsrgsew">{{text.product22}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/lsjyew">{{text.product23}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/ysyew">{{text.product24}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/rjew">{{text.product25}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/lasew">{{text.product26}}</router-link>
                    </li>
                  </ul>
                  <p class="littitle">{{text.product27}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productew/hgylew">{{text.product28}}</router-link>
                    </li>
                  </ul>
                  <p class="littitle">{{text.product29}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/productew/gtllew">{{text.product30}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/jsmdew">{{text.product31}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/productew/bxxew">{{text.product32}}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.product33}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="cont_r_b10">
              <router-link to="/bbsew" target="_blank">
                <img :src="images.scy_03">
              </router-link>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        scy_03: require("../../../assets/img/ew/scy_03.jpg"),
        cps_03: require("../../../assets/img/ew/cps_03.jpg")
      },
      text: {
        profile3: "",
        profile4: "Главная страница",
        product1: "Цветные металлы",
        product2: "Латунная чушка/бронзовая чушка/медная чушка",
        product3: "Алюминиевый рулон/алюминиевый лист/алюминиевая фол",
        product4: "Вторичная свинцовая чушка/вторичная цинковая чушка",
        product5: "Руды, редкоземельные металлы, ферросплавы",
        product6: "Хромовая руда/марганцевая руда",
        product7: "Мишметалл",
        product8: "Редкоземельный силицидный сплав",
        product9: "Металлический кремний",
        product10: "Ферроникель/ферросилиций/ферромарганец/ферросилико",
        product11: "Углеродное изделие и",
        product12: "Электрод",
        product13: "Угольный блок/анод/масса электродная/графитовый бл",
        product14: "Металлургический уголь",
        product15: "Сырье для медицины и",
        product16: "Гиперзин-А",
        product17: "Чайный экстракт",
        product18: "Теафлавин/растворимый чай",
        product19: "Экстракт пуэрарии",
        product20: "Экстракт расторопши",
        product21: "Косточки винограда экстракт",
        product22: "Сульфат хондроитина",
        product23: "Глюкозамин сульфат калий",
        product24: "Глюкозамин гидрохлорид",
        product25: "L-карнитин",
        product26: "L-тирозин/L-аргинин/альфа-липоевая кислота",
        product27: "Сырье для химической",
        product28: "Диоксид титана/безводный карбонат натрия/фторид ал",
        product29: "Сталь и шихта",
        product30: "Марганцевая чушка/марганцевой чешуйчатый/марганцев",
        product31: "Магниевая чушка/магний гранулированный, кальций гр",
        product32: "Порошковая проволока",
        product33: "Продукция"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/product/product.vue